<template>
  <BasicLayout>
    <template #wrapper>
      <el-card :bordered="false" :body-style="{padding: '0'}">

        <div class="salesCard">
          <el-form :inline="true">
            <el-form-item label="用户类型" prop="level">
              <el-select
                v-model.number="queryParams1.type"
                placeholder="请选择类型"
                clearable
                size="small"
                @keyup.enter.native="handleQuery"
              >
                <el-option
                  v-for="(item, index) in userType"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="开始日期">
              <el-date-picker
                v-model="queryParams1.startDate"
                placeholder="请选择日期"
                clearable
                value-format="yyyy-MM-dd"
                type="date"
                size="small"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="结束日期">
              <el-date-picker
                v-model="queryParams1.endDate"
                placeholder="请选择日期"
                clearable
                value-format="yyyy-MM-dd"
                type="date"
                size="small"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item>
              <el-button :loading="loading" type="primary" icon="el-icon-search" size="mini" @click="handleQuery(0)">查询</el-button>
              <!--              <el-button v-if="isExport" type="primary" icon="el-icon-download" size="mini" @click="handleQuery(1)">导出</el-button>-->
            </el-form-item>
          </el-form>
          <div ref="chartContainer" style="width: 100%; height: 400px;" />
        </div>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import echarts from 'echarts'
import { getUserConsumeStat } from '@/api/statistics/user_remain'
import { dateStrTodate, getLastDates, getUserConsumeLabel } from '@/utils'
export default {
  name: 'IndexNetDepletionStat',
  props: {
    isExport: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      userType: [],
      loading: false,
      chartData: {},
      queryParams1: {
        startDate: '',
        endDate: '',
        type: 0,
        level: 0
      }
    }
  },
  created() {
    this.queryParams1.startDate = getLastDates(7)
    this.queryParams1.endDate = getLastDates(1)
    this.userType = getUserConsumeLabel()
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleQuery(isExport = 0) {
      if (!this.queryParams1.startDate) {
        this.msgError('开始日期不能为空')
        return
      }

      if (!this.queryParams1.endDate) {
        this.msgError('结束日期不能为空')
        return
      }
      if (this.queryParams1.startDate > this.queryParams1.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }
      this.initChart(isExport)
    },
    initChart(isExport = 0) {
      const chart = echarts.init(this.$refs.chartContainer)
      chart.showLoading()
      this.loading = true
      const option = {
        color: ['#00BFFF', '#FF69B4', '#FF7F50', '#BA55D3', '#FFA500', '#7B68EE'],
        title: {
          text: '人均净发放'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: ['人均净发放金币', '人均净发放体力', '人均净发放钻石', '人均净发放野兽币', '人均消耗体力', '人均发放体力'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          },
          axisLine: {
            show: false // 隐藏 y 轴的竖线
          }
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: { readOnly: false },
            // magicType: { type: ['line', 'bar'] },
            // restore: {},
            // saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '人均净发放金币',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '人均净发放体力',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '人均净发放钻石',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '人均净发放野兽币',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '人均发放体力',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '人均消耗体力',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }
        ]
      }
      chart.setOption(option)
      setTimeout(() => {
        // this.queryParams1.level = 0
        // if (isExport) {
        // this.queryParams1.level = 1
        // }
        getUserConsumeStat(this.queryParams1).then(res => {
          chart.hideLoading()
          this.loading = false
          if (res.code === 200) {
            this.queryParams1.startDate = res.data.req.startDate
            this.queryParams1.endDate = res.data.req.endDate
            // if (this.queryParams1.level === 1) {
            //   window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
            // }
            if (res.data.length < 1) {
              return
            }
            const date = []
            const costCoin = []
            const costSpin = []
            const costDiamond = []
            const costBeastCoin = []
            const grantAvgSpin = []
            const costAvgSpin = []
            res.data.data.forEach(item => {
              date.push(dateStrTodate(item.date))
              costCoin.push(item.user_grant_coin)
              costSpin.push(item.user_grant_spins)
              costDiamond.push(item.user_grant_diamond)
              costBeastCoin.push(item.user_grant_beast_coin)
              grantAvgSpin.push(item.grant_spin_avg)
              costAvgSpin.push(item.cost_spin_avg)
            })

            option.xAxis.data = date
            option.series[0].data = costCoin
            option.series[1].data = costSpin
            option.series[2].data = costDiamond
            option.series[3].data = costBeastCoin
            option.series[4].data = grantAvgSpin
            option.series[5].data = costAvgSpin
            chart.setOption(option)
          } else {
            this.msgError(res.msg)
          }
        })
      }, 800)
    }
  }
}
</script>

  <style scoped />
